import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'

import { Modal, Paper, Button } from 'material-ui'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import AssignmentIcon from 'material-ui-icons/Assignment'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import BookIcon from 'material-ui-icons/Book'

import { newBook, updateBook, deleteBook } from '@/graphql/mutations/book'

import { GC_USER_ID } from '@/constants'

import DeleteModal from '../modals/Delete'

@graphql(newBook, {
  name: 'newBook',
  options: {
    refetchQueries: ['booksQuery']
  }
})
@graphql(updateBook, {
  name: 'updateBook',
  options: {
    refetchQueries: ['booksQuery']
  }
})
@graphql(deleteBook, {
  name: 'deleteBook',
  options: {
    refetchQueries: ['booksQuery']
  }
})
export default class BookEditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      OpenDelete: false,
      book: '',
      loadingBook: false,
      loadingDel: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }

    if (nextProps.book !== this.props.book) {
      this.setState({ book: nextProps.book })
    }
  }

  handleSaveBook = () => {
    this.setState({ loadingBook: true })
    if (this.props.action === 'add') {
      this.props
        .newBook({
          variables: {
            name: this.state.book.name,
            author: this.state.book.author,
            totalPages: this.state.book.totalPages,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false,
            loadingBook: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false,
            loadingBook: false
          })
        })
    } else if (this.props.action === 'edit') {
      this.props
        .updateBook({
          variables: {
            name: this.state.book.name,
            author: this.state.book.author,
            totalPages: this.state.book.totalPages,
            id: this.state.book.id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false,
            loadingBook: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false,
            loadingBook: false
          })
        })
    }
  }

  handleChangeBook = name => event => {
    var newBook = Object.assign({}, this.state.book)
    switch (name) {
      case 'totalPages':
        newBook[name] = parseInt(event.target.value, 10)
        break
      default:
        newBook[name] = event.target.value
        break
    }
    this.setState({ book: newBook })
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleOpenDelete = () => {
    this.setState({
      OpenDelete: true
    })
  }

  handleCloseDelete = () => {
    this.setState({
      OpenDelete: false
    })
  }

  handleDelete = id => {
    this.setState({ loadingBook: true, loadingDel: true })
    this.props
      .deleteBook({
        variables: {
          id: id
        }
      })
      .then(() => {
        this.props.onClose()
        this.setState({
          OpenDelete: false,
          open: false,
          actionBook: '',
          loadingBook: false,
          loadingDel: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.props.onClose()
        this.setState({
          OpenDelete: false,
          open: false,
          actionBook: '',
          loadingBook: false,
          loadingDel: false
        })
      })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddTodayEdit" style={{ borderRadius: 16 }}>
            <div id="clearBtnBedTime" className="divAddTpday">
              <div className="divClearButton">
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleClose}
                >
                  <ClearIcon className="iconClear" />
                </IconButton>
              </div>
              {this.state.book && (
                <List>
                  <ListItem className="listItemSleepTimeComplete">
                    <ListItemIcon>
                      <BookIcon className="editIcons" />
                    </ListItemIcon>
                    <TextField
                      id="name"
                      label="Book Name"
                      className="textFieldLong"
                      value={this.state.book.name ? this.state.book.name : ''}
                      onChange={this.handleChangeBook('name')}
                      margin="normal"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>

                  <ListItem className="modalContentSmallTime">
                    <ListItemIcon>
                      <AssignmentIcon className="iconSleepAtTimeDate" />
                    </ListItemIcon>
                    <TextField
                      id="author"
                      label="Author"
                      className="textFieldLong"
                      value={
                        this.state.book.author ? this.state.book.author : ''
                      }
                      onChange={this.handleChangeBook('author')}
                      margin="normal"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>
                  <ListItem className="modalContentSmallTime">
                    <ListItemIcon>
                      <AssignmentIcon className="iconSleepAtTimeDate" />
                    </ListItemIcon>
                    <TextField
                      id="totalPages"
                      label="Total Pages"
                      className="textFieldLong"
                      value={
                        this.state.book.totalPages
                          ? this.state.book.totalPages
                          : ''
                      }
                      onChange={this.handleChangeBook('totalPages')}
                      margin="normal"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>
                  <ListItem className="modalContentDone">
                    {this.props.action === 'edit' && (
                      <Button
                        onClick={this.handleOpenDelete}
                        className="iconBtnCheck"
                        size="small"
                      >
                        {' '}
                        <span style={{ color: 'grey', fontSize: 15 }}>
                          Delete
                        </span>
                      </Button>
                    )}
                    <ListItemText />
                    <Button
                      onClick={this.handleClose}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Cancel
                      </span>
                    </Button>
                    <Button
                      onClick={this.handleSaveBook}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>Save</span>
                      <ChevronRightIcon
                        style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                      />
                    </Button>
                  </ListItem>
                </List>
              )}
            </div>
          </Paper>
        </Modal>
        <DeleteModal
          open={this.state.OpenDelete}
          onClose={this.handleCloseDelete}
          yes={() => this.handleDelete(this.state.book.id)}
          loading={this.state.loadingDel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/BookEdit.js